import { createContext } from 'react';
export const HideWhenDetachedContext = createContext(undefined);
HideWhenDetachedContext.displayName = 'AetherHideWhenDetachedContext';
//# sourceMappingURL=context.js.map